// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const WarningLg = ({ color = "white", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M20.0429 20.9999H3.95707C2.41904 20.9999 1.4566 19.3363 2.22326 18.003L10.2662 4.01527C11.0352 2.67786 12.9648 2.67785 13.7338 4.01526L21.7768 18.003C22.5434 19.3363 21.581 20.9999 20.0429 20.9999Z" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M12 9V13" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M12 17.0092L12.0094 16.9988" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
